import {IPaymentsState, PaymentsActions} from "./types";
import {Reducer} from "redux";
import {getType} from "typesafe-actions";
import {consume, purchase, setPaymentsIsReady} from "./actions";
import { SDK } from "../../sdk";

const initialState: IPaymentsState = {
    isSupported: SDK.instance.supports.payments,
    isReady: false,
    purchaseInProgress: false,
    consumeInProgress: false,
};

export const paymentsReducer : Reducer<IPaymentsState, PaymentsActions> = (state = initialState, action) => {
    switch (action.type) {
        case getType(setPaymentsIsReady):
            return {
                ...state,
                isReady: true
            };

        case getType(purchase.request):
            return {
                ...state,
                purchaseInProgress: true
            };

        case getType(purchase.success):
        case getType(purchase.failure):
            return {
                ...state,
                purchaseInProgress: false
            };

        case getType(consume.request):
            return {
                ...state,
                consumeInProgress: true
            };

        case getType(consume.success):
        case getType(consume.failure):
            return {
                ...state,
                consumeInProgress: false
            };

        default:
            return state;
    }
};
